






















import Vue from 'vue';
import VueAvatar from 'vue-avatar';
import { Component, Prop } from 'vue-property-decorator';

@Component({
  name: 'bpc-avatar',
  components: {
    avatar: VueAvatar,
  },
})
export default class Avatar extends Vue {
  @Prop(String) readonly avatarUrl: string;
  @Prop({ type: String, default: '' }) readonly username: string;
  @Prop({ type: Number, default: 44 }) readonly size: number;
  @Prop({ type: Number, default: 44 }) readonly width: number;
  @Prop({ type: Number, default: 44 }) readonly height: number;

  onImgError(event) {
    this.$emit('img-error', event);
  }
}
